import Breaker from './breaker.png';

export const getImageBreaker = () => {
  return Breaker;
};
